import React, { useState } from 'react';

import GeneralRiskImpactCategoriesTableEditRow from './GeneralRiskImpactCategoriesTableEditRow';
import GeneralRiskImpactCategoriesTableRow from './GeneralRiskImpactCategoriesTableRow';

export default function GeneralRiskImpactCategoriesTable(props) {
    const [editableImpactCategory, setEditableImpactCategory] = useState(null);

    const prepareUpdateUrl = (impactCategory) => {
        return props.updateUrl.replace('IMPACT_CATEGORY_ID', impactCategory.id);
    };

    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th className="tw-w-44">{$t('Impact Category')}</th>
                        <th>{$t('Description')}</th>
                        <th className="tw-w-40">{$t('Actions')}</th>
                    </tr>
                </thead>
                <tbody>
                    {!props.isLoading &&
                        !!props.impactCategories?.length &&
                        props.impactCategories.map((impactCategory) => {
                            if (editableImpactCategory && parseInt(editableImpactCategory.id) === parseInt(impactCategory.id)) {
                                return (
                                    <GeneralRiskImpactCategoriesTableEditRow
                                        key={impactCategory.id}
                                        impactCategory={impactCategory}
                                        updateUrl={prepareUpdateUrl(impactCategory)}
                                        onUpdated={props.fetch}
                                        onCancel={() => setEditableImpactCategory(null)}
                                    />
                                );
                            } else {
                                return (
                                    <GeneralRiskImpactCategoriesTableRow
                                        key={impactCategory.id}
                                        impactCategory={impactCategory}
                                        onEdit={() => setEditableImpactCategory(impactCategory)}
                                        onDelete={() => props.onDelete(impactCategory)}
                                    />
                                );
                            }
                        })}
                    {props.isLoading && (
                        <tr>
                            <td colSpan="100">{$t('Loading')}...</td>
                        </tr>
                    )}
                    {!props.isLoading && !props.impactCategories?.length && (
                        <tr>
                            <td colSpan="100">{$t('No Impact Categories found')}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
